module.exports = __webpack_public_path__ + "img/check-mark.7ec7755a.svg";